import { SET_VIEWPORT_SIZE } from 'actions';
import { ViewportSize } from 'typings';

export function setViewportSize(viewportSize: ViewportSize) {
  return { type: SET_VIEWPORT_SIZE, viewportSize };
}
